<script lang="ts">
const __DsBlock = {
	icon: 'lucide:baseline',
	description: 'A simple text block.',
	category: 'basic',
	options: [
		{
			name: 'text',
		},
		{
			name: 'size',
			type: 'enum',
			values: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'],
		},
		{
			name: 'weight',
			type: 'enum',
			values: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black'],
		},
		{
			name: 'align',
			type: 'enum',
			values: ['start', 'center', 'end', 'justify'],
		},
	],
}
</script>
<script lang="ts" setup>
import { defineBlock } from '#layers/block-engine';

type TextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl' | '9xl';
type TextWeight = 'thin' | 'extralight' | 'light' | 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold' | 'black';
type TextAlign = 'start' | 'center' | 'end' | 'justify';

withDefaults(defineProps<{
	/**
	 * The text to display.
	 */
	text?: string;

	size?: TextSize;
	weight?: TextWeight;
	align?: TextAlign;
}>(), {
	text: 'Hello world',
});

;
</script>

<template>
	<div
		class="whitespace-pre-wrap"
		:class="{
			[`text-${size}`]: size,
			[`font-${weight}`]: weight,
			[`text-${align}`]: align,
		}"
		v-text="text"
	/>
</template>
